(function () {
  'use strict';

  if (window.ClubLpOrder) return;

  var SELECTOR = {
    root: '[data-club-order-root]',
    order: '[data-club-order]',
    label: '[data-club-order-label]',
    status: '[data-club-order-status]',
    popup: '[data-club-popup]',
    openPopup: '[data-club-popup][open]',
    popupClose: '[data-club-popup-close]',
    busy: '[data-club-order].is-busy',
    // sections/club-lp-analytics.liquid: the landing's variant (A / B / C)
    analytics: '[data-club-lp-analytics]',
  };

  var BUSY_CLASS = 'is-busy';
  var LIMIT_POPUP = 'limit';

  var ORDER_ATTRIBUTES = {
    delivery_date: '',
    order_source: 'landing',
    club_offer: '',
    club_order: '',
  };

  var RESET_ATTRIBUTES = {
    delivery_date: '',
    order_source: '',
    club_offer: '',
    club_order: '',
  };

  var isSubmitting = false;

  var idleContent = new WeakMap();

  var lockedOverflow = null;

  function reportError(message, err) {
    console.error(message, err);
    if (window.Sentry && typeof window.Sentry.captureException === 'function') {
      window.Sentry.captureException(err);
    }
  }

  function attr(el, name) {
    return (el.getAttribute(name) || '').trim();
  }

  function toId(value) {
    var n = parseInt(value, 10);
    return isNaN(n) || n <= 0 ? 0 : n;
  }

  function londonToday() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    var get = function (type) {
      return Number(parts.find(function (p) { return p.type === type; }).value);
    };
    return new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12, 0, 0));
  }

  function parseIsoDate(raw) {
    if (!raw) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(raw).trim());
    if (!m) return null;
    return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0));
  }

  function todayKey() {
    return londonToday().toISOString().slice(0, 10);
  }

  function isLoggedIn(root) {
    return attr(root, 'data-club-logged-in') === 'true';
  }

  function isPaidPeriodOver(root) {
    var paidUntil = parseIsoDate(attr(root, 'data-club-paid-until'));
    return Boolean(paidUntil) && paidUntil.getTime() < londonToday().getTime();
  }

  function clubState(root) {
    if (!isLoggedIn(root)) return 'guest';
    if (isPaidPeriodOver(root)) return 'expired';
    if (attr(root, 'data-club-member') === 'true') return 'member';
    if (attr(root, 'data-club-trial-used') === 'true') return 'returning';
    return 'guest';
  }

  function hasOrderedToday(root) {
    if (!isLoggedIn(root)) return false;
    var last = attr(root, 'data-club-last-order');
    return last !== '' && last === todayKey();
  }

  function clubConfig() {
    var club = window.PXUTheme && window.PXUTheme.club;
    return club && toId(club.variantId) ? club : null;
  }

  function sellingPlan(root, club) {
    var state = clubState(root);
    var trial = toId(club.planTrial);
    if (state === 'returning' || state === 'expired') return toId(club.planRenew) || trial;
    return trial;
  }

  function cartService() {
    var svc = window.CartService;
    if (!svc) return null;
    if (typeof svc.prepareCheckout !== 'function') return null;
    if (typeof svc.resetSession !== 'function') return null;
    return svc;
  }

  function buildOrder(root, btn) {
    if (root.hasAttribute('data-club-order-disabled')) return null;
    var variantId = toId(btn.getAttribute('data-club-variant-id'));
    var club = clubConfig();
    var cart = cartService();
    if (!variantId || !club || !cart) return null;

    var bouquet = {
      variantId: variantId,
      quantity: 1,
      properties: { _order_source: 'landing' },
    };
    if (btn.getAttribute('data-club-bouquet') === 'true') bouquet.properties._club_landing = 'true';
    // The landing variant rides on the bouquet line, like _club_landing: the
    // checkout pixels read it from lineItems[].properties and it stays on the order
    var analytics = document.querySelector(SELECTOR.analytics);
    var variant = analytics ? analytics.getAttribute('data-variant') : '';
    if (variant) bouquet.properties._ig_variant = variant;
    var items = [bouquet];

    if (clubState(root) !== 'member') {
      var plan = sellingPlan(root, club);
      if (!plan) return null;
      items.push({ variantId: toId(club.variantId), quantity: 1, sellingPlan: plan });
    }

    return { cart: cart, items: items };
  }

  function labelOf(btn) {
    return btn.querySelector(SELECTOR.label) || btn;
  }

  function setBusy(btn) {
    var label = labelOf(btn);
    if (!idleContent.has(btn)) idleContent.set(btn, label.innerHTML);
    var busy = btn.getAttribute('data-club-busy-text');
    if (busy) label.textContent = busy;
    btn.classList.add(BUSY_CLASS);
    btn.setAttribute('aria-busy', 'true');
  }

  function setIdle(btn) {
    if (idleContent.has(btn)) {
      labelOf(btn).innerHTML = idleContent.get(btn);
      idleContent.delete(btn);
    }
    btn.classList.remove(BUSY_CLASS);
    btn.removeAttribute('aria-busy');
  }

  function setStatus(root, text) {
    var status = root.querySelector(SELECTOR.status);
    if (status) status.textContent = text || '';
  }

  function lockScroll() {
    if (lockedOverflow !== null) return;
    var html = document.documentElement;
    lockedOverflow = html.style.overflow;
    html.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (lockedOverflow === null) return;
    document.documentElement.style.overflow = lockedOverflow;
    lockedOverflow = null;
  }

  function syncScrollLock() {
    if (!document.querySelector(SELECTOR.openPopup)) unlockScroll();
  }

  function popupFor(root, name) {
    var popups = root.querySelectorAll(SELECTOR.popup);
    for (var i = 0; i < popups.length; i += 1) {
      if (popups[i].getAttribute('data-club-popup') === name) return popups[i];
    }
    return null;
  }

  function closePopup(popup) {
    if (!popup || !popup.hasAttribute('open')) return;
    if (typeof popup.close === 'function') {
      popup.close();
    } else {
      popup.removeAttribute('open');
    }
    syncScrollLock();
  }

  function closeAllPopups(scope) {
    (scope || document).querySelectorAll(SELECTOR.openPopup).forEach(closePopup);
  }

  function openPopup(root, name) {
    var popup = popupFor(root, name);
    if (!popup) return false;
    closeAllPopups();
    if (typeof popup.showModal === 'function') {
      popup.showModal();
    } else {
      popup.setAttribute('open', '');
    }
    lockScroll();
    return true;
  }

  // --- Cart -----------------------------------------------------------------
  function rollback(cart) {
    // Один /cart/update.js: все строки в 0 + атрибуты (cart-service.js resetSession)
    return cart
      .resetSession({ attributes: RESET_ATTRIBUTES })
      .catch(function (err) {
        reportError('Club landing: cart rollback failed', err);
      });
  }

  function submit(root, btn, order) {
    isSubmitting = true;
    setBusy(btn);
    setStatus(root, '');

    // Корзина собирается сервисом: clear.js → один add.js → перечитывание и
    // ремонт до устойчивого состояния (cart-service.js settleCheckout); снимок
    // корзины и прогрев кэша больше не нужны. exclusive — в чекаут уходят ровно
    // букет и членство, сбор аппа клубному заказу не положен.
    order.cart
      .prepareCheckout({
        items: order.items,
        attributes: ORDER_ATTRIBUTES,
        clear: 'auto',
        exclusive: true,
      })
      .then(function () {
        // MFS-5764: the club card step (£2.99) first, then checkout
        var clubCfg = window.PXUTheme && window.PXUTheme.club;
        window.location.href = (clubCfg && clubCfg.cardStepUrl) || '/checkout';
      })
      .catch(function (err) {
        reportError('Club landing: add to cart failed', err);
        return rollback(order.cart).then(function () {
          isSubmitting = false;
          setIdle(btn);
          setStatus(root, root.getAttribute('data-club-error-text'));
        });
      });
  }

  // --- Events ---------------------------------------------------------------
  function onClick(e) {
    var closer = e.target.closest(SELECTOR.popupClose);
    if (closer) {
      var popup = closer.closest(SELECTOR.popup);
      if (popup) {
        e.preventDefault();
        closePopup(popup);
      }
      return;
    }

    var btn = e.target.closest(SELECTOR.order);
    if (!btn) return;
    // Modified clicks keep the link's own behaviour (open the product in a new tab).
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var root = btn.closest(SELECTOR.root);
    if (!root) return;

    var order = buildOrder(root, btn);
    if (!order) return;
    e.preventDefault();
    if (isSubmitting) return;

    // The daily limit is checked before anything is written to the cart.
    if (hasOrderedToday(root)) {
      openPopup(root, LIMIT_POPUP);
      return;
    }
    submit(root, btn, order);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') closeAllPopups();
  }

  function onDialogClose(e) {
    if (e.target && e.target.matches && e.target.matches(SELECTOR.popup)) syncScrollLock();
  }

  function onSectionUnload(e) {
    closeAllPopups(e.target);
    var elsewhere = Array.prototype.some.call(document.querySelectorAll(SELECTOR.openPopup), function (popup) {
      return !e.target.contains(popup);
    });
    if (!elsewhere) unlockScroll();
  }

  // Back from checkout (bfcache) brings the page back mid-submit.
  function onPageShow(e) {
    if (!e.persisted) return;
    isSubmitting = false;
    document.querySelectorAll(SELECTOR.busy).forEach(setIdle);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeyDown);
  document.addEventListener('close', onDialogClose, true);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  window.addEventListener('pageshow', onPageShow);

  window.ClubLpOrder = {
    clubState: clubState,
    hasOrderedToday: hasOrderedToday,
    openPopup: openPopup,
    closePopups: closeAllPopups,
  };
})();
